import { useMemo } from 'react'

// Ниже этой ширины контейнера кнопкам в панели контролов физически негде
// поместиться (проверено на старом ModalVideoContent — та же цифра).
const MIN_WIDTH = 380

// Вписывает видео в допустимую область вьюпорта (как в полноэкранной модалке
// поста), сохраняя пропорции, и гарантирует минимальную ширину контейнера —
// иначе вертикальное видео сожмётся до узкой полоски вместе с панелью контролов.
export function useModalFitSize(videoWidth, videoHeight, { maxWidthVw = 0.9, maxHeightVh = 0.88 } = {}) {
    return useMemo(() => {
        if (!videoWidth || !videoHeight) return null

        const maxW = window.innerWidth * maxWidthVw
        const maxH = window.innerHeight * maxHeightVh
        const ratio = videoWidth / videoHeight

        let w = maxH * ratio
        let h = maxH

        if (w > maxW) {
            w = maxW
            h = w / ratio
        }

        // Минимальная ширина не должна выигрывать у размера экрана: на узком
        // телефоне (360px) MIN_WIDTH в 380px делал контейнер шире вьюпорта, и
        // сильно вертикальное видео вылезало за края. Экран важнее — контролы
        // в таком случае просто ужимаются.
        w = Math.min(Math.max(w, MIN_WIDTH), maxW)

        return { width: Math.round(w), height: Math.round(h) }
    }, [videoWidth, videoHeight, maxWidthVw, maxHeightVh])
}
